export const iconFontAwesomeMapsFlask = (
	<i className="fa-solid fa-flask"></i>
);
